import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors, easing, layout, media, radii, shadows } from "../../../theme";

const honeycombPattern = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56' height='100' viewBox='0 0 56 100'%3E%3Cpath d='M28 66L0 50L0 16L28 0L56 16L56 50L28 66L28 100' fill='none' stroke='%23D2B48C' stroke-opacity='0.45' stroke-width='1'/%3E%3Cpath d='M28 0L28 34L0 50L0 84L28 100L56 84L56 50L28 34' fill='none' stroke='%23D2B48C' stroke-opacity='0.45' stroke-width='1'/%3E%3C/svg%3E")`;

export const QuickLinksRoot = styled.section`
  padding: clamp(4.5rem, 9vw, 7rem) ${layout.gutter};
  background: radial-gradient(
      ellipse at center,
      rgba(255, 255, 234, 0.6) 0%,
      ${colors.backgroundMain} 75%
    ),
    ${honeycombPattern}, ${colors.backgroundMain};
`;

export const QuickLinksHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  max-width: 40rem;
  margin: 0 auto 3.5rem;
  text-align: center;
`;

export const QuickLinksContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
`;

export const QuickLinkIcon = styled.span`
  display: grid;
  place-items: center;
  width: 5.25rem;
  height: 5.25rem;
  border-radius: 50%;
  background-color: ${colors.primary};
  color: ${colors.secondary};
  font-size: 2.6rem;
  transition: transform 0.6s ${easing.out}, background-color 0.3s ease;
`;

export const QuickLinkTitle = styled.h3`
  font-size: 1.35rem;
  text-align: center;
`;

export const QuickLinkArrow = styled.span`
  display: grid;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid rgba(210, 180, 140, 0.7);
  border-radius: 50%;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-color 0.3s ease, transform 0.4s ${easing.out};
`;

export const QuickLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.1rem;
  height: 100%;
  padding: 2.5rem 1.5rem 2rem;
  border: 1px solid rgba(210, 180, 140, 0.45);
  border-radius: ${radii.lg};
  background-color: ${colors.backgroundSecondary};
  color: ${colors.textMain};
  text-decoration: none;
  transition: transform 0.5s ${easing.out}, box-shadow 0.5s ${easing.out},
    border-color 0.3s ease;

  ${media.hoverable} {
    &:hover {
      transform: translateY(-8px);
      border-color: ${colors.primary};
      box-shadow: ${shadows.lg};
    }

    &:hover ${QuickLinkIcon} {
      transform: rotate(-8deg) scale(1.08);
      background-color: ${colors.buttonHover};
    }

    &:hover ${QuickLinkArrow} {
      background-color: ${colors.secondary};
      border-color: ${colors.secondary};
      color: ${colors.primary};
      transform: translateX(4px);
    }
  }
`;
